import { PermanentJobsApi } from '../clients';

/**
 * Creates a new job posting or publishes an existing draft
 * Service layer that orchestrates the API call and extracts the posting ID
 *
 * @param {import('../types/CreateJobPosting.parameters').ICreateJobPostingPayload} payload - Request payload
 *   - If payload.postingId is present: publishes existing draft
 *   - If payload.postingId is absent: creates new posting
 *
 * @returns {Promise<string>} The posting ID
 *   - For new postings: returns the newly created posting ID from server
 *   - For published drafts: returns the existing posting ID from payload
 */
export const createOrPublishJobPosting = async (payload) => {
  const response = await PermanentJobsApi.createOrPublishJobPosting(payload);

  return response.data.postingId;
};
